import { Controller } from 'stimulus'
import { createPopper } from '@popperjs/core';

export default class extends Controller {
  static targets = [ 'input', 'name' ]

  connect() {
    // const checkboxes = this.inputTargets,
    // costField = document.getElementById('cost'),
    // discountField = document.getElementById('discount')
    // var cost = 0
    // for (var i=0; i<checkboxes.length; i++) {
    //   if (checkboxes[i].type === "checkbox" && checkboxes[i].checked === true){
    //     cost = cost + parseInt(checkboxes[i].dataset.cost)
    //   }
    // }
    // var percent = cost / 100  * 10
    // costField.innerHTML = cost.toLocaleString() + ' ₽'
    // discountField.innerHTML = (cost - percent).toLocaleString() + ' ₽'
  }

  // calculate(){
  //   const checkboxes = this.inputTargets,
  //   costField = document.getElementById('cost'),
  //   discountField = document.getElementById('discount')
  //   var cost = 0
  //   for (var i=0; i<checkboxes.length; i++) {
  //     if (checkboxes[i].type === "checkbox" && checkboxes[i].checked === true){
  //       cost = cost + parseInt(checkboxes[i].dataset.cost)
  //     }
  //   }
  //   var percent = cost / 100  * 10
  //   costField.innerHTML = cost.toLocaleString() + ' ₽'
  //   discountField.innerHTML = (cost - percent).toLocaleString() + ' ₽'
  // }

  tooltip(el){
    const popperButton = el.target,
    popperPopup = popperButton.nextElementSibling,
    popperArrow = popperPopup.lastElementChild
    let popperInstance = null;
    if (el.type == 'mouseover' || el.type == 'touchenter' || el.type == 'touchleave' || el.type == 'mouseout') {
      togglePopper();
    }
    function createInstance() {
      popperInstance = createPopper(popperButton, popperPopup, {
        placement: "top", //preferred placement of popper
        modifiers: [
          {
            name: "offset", //offsets popper from the reference/button
            options: {
              offset: [-150, 20]
            }
          },
          {
            name: "flip", //flips popper with allowed placements
            options: {
              allowedAutoPlacements: ["right", "left", "top", "bottom"],
              rootBoundary: "viewport"
            }
          }
        ]
      });
    }
    function destroyInstance() {
      if (popperInstance) {
        popperInstance.destroy();
        popperInstance = null;
      }
    }
    function showPopper() {
      popperPopup.classList.remove('hidden')
      popperPopup.setAttribute("show-popper", "");
      createInstance();
    }
    function hidePopper() {
      popperPopup.classList.add('hidden')
      popperPopup.removeAttribute("show-popper");
      destroyInstance();
    }
    function togglePopper() {
      if (popperPopup.hasAttribute("show-popper")) {
        hidePopper();
      } else {
        showPopper();
      }
    }
  }
}